{
  "menu": {
    "home": "Home",
    "features": "Features",
    "pricing": "Pricing",
    "about": "About",
    "contact": "Contact",
    "blog": "Blog",
    "support": "Support",
    "dashboard": "Dashboard",
    "profile": "Profile",
    "settings": "Settings",
    "logout": "Logout",
    "login": "Login",
    "signup": "Sign Up"
  },
  "footer": {
    "company": {
      "title": "Company",
      "about": "About Us",
      "careers": "Careers",
      "press": "Press",
      "partners": "Partners"
    },
    "product": {
      "title": "Product",
      "features": "Features",
      "pricing": "Pricing",
      "security": "Security",
      "roadmap": "Roadmap"
    },
    "resources": {
      "title": "Resources",
      "documentation": "Documentation",
      "tutorials": "Tutorials",
      "blog": "Blog",
      "community": "Community"
    },
    "legal": {
      "title": "Legal",
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "cookies": "Cookie Policy",
      "compliance": "Compliance"
    },
    "social": {
      "title": "Follow Us",
      "twitter": "Twitter",
      "linkedin": "LinkedIn",
      "facebook": "Facebook",
      "youtube": "YouTube"
    },
    "copyright": "© 2024 Sigma08. All rights reserved."
  },
  "breadcrumb": {
    "home": "Home",
    "separator": "/"
  },
  "accessibility": {
    "skipToContent": "Skip to main content",
    "mainNavigation": "Main navigation",
    "userMenu": "User menu",
    "languageSelector": "Language selector"
  }
}
